module.exports = __webpack_public_path__ + "img/logo-placeholder.d27948ef.png";